import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';

import { useAuthContext } from 'src/auth/hooks';
import { NavUpgrade } from 'src/layouts/components/nav-upgrade';

import { NavList } from './nav-list';
import { NavUl, NavLi, Subheader } from '../styles';
import { navSectionClasses } from '../classes';
import { navSectionCssVars } from '../css-vars';

// ----------------------------------------------------------------------

export function NavSectionMini({
  sx,
  data,
  render,
  slotProps,
  enabledRootRedirect,
  cssVars: overridesVars,
}) {
  const theme = useTheme();

  const { user } = useAuthContext();

  const allowed = (userTypes) => {
    if (!userTypes) return true;
    const userRoles = user?.role?.map((role) => role.name) || [];

    return userTypes.some((type) => userRoles.includes(type));
  };

  const cssVars = {
    ...navSectionCssVars.mini(theme),
    ...overridesVars,
  };

  return (
    <Stack component="nav" className={navSectionClasses.mini.root} sx={{ ...cssVars, ...sx }}>
      <NavUl sx={{ flex: '1 1 auto', gap: 'var(--nav-item-gap)' }}>
        {data.map((group) => {
          const { userTypes } = group;

          const allowedUserType = allowed(userTypes);

          // If it's a single nav item (no items array), render it directly
          if (!group?.items && group?.title) {
            return allowedUserType ? (
              <NavList
                key={group.title}
                data={group}
                render={render}
                depth={1}
                cssVars={cssVars}
                slotProps={slotProps}
                enabledRootRedirect={enabledRootRedirect}
              />
            ) : null;
          }

          // Otherwise, render as a group
          return (
            <Group
              key={group?.subheader ?? group?.items?.[0]?.title ?? group?.title}
              subheader={allowedUserType && group?.subheader}
              items={group?.items}
              render={render}
              cssVars={cssVars}
              slotProps={slotProps}
              enabledRootRedirect={enabledRootRedirect}
            />
          );
        })}
      </NavUl>
      <NavUpgrade />
    </Stack>
  );
}

// ----------------------------------------------------------------------

function Group({ items, render, subheader, slotProps, enabledRootRedirect, cssVars }) {
  const renderContent = items ? (
    <NavUl sx={{ gap: 'var(--nav-item-gap)' }}>
      {items.map((list) => (
        <NavList
          key={list.title}
          depth={1}
          data={list}
          render={render}
          cssVars={cssVars}
          slotProps={slotProps}
          enabledRootRedirect={enabledRootRedirect}
        />
      ))}
    </NavUl>
  ) : null;

  return (
    <NavLi>
      {subheader ? (
        <>
          {/* <Subheader
            data-title={subheader}
            sx={slotProps?.subheader}
          >
            {subheader}
          </Subheader> */}
          {renderContent}
        </>
      ) : (
        renderContent
      )}
    </NavLi>
  );
}
